import { useEffect, useState } from "react";

import AppBackground from "../branding/AppBackground";
import SplashLoading from "./splashLoading/SplashLoading";
import MenuPage from "../pages/menu/MenuPage";
import Toast from "../components/toast/Toast";
import Config from "../config";

import ConnectionPopup from "../popups/connection/ConnectionPopup";
import ExitPopup from "../popups/exitPopup/ExitPopup";

import useStore from "../hooks/useStore";
import useVisibility from "../hooks/useVisibility";

import Platform from "../services/platform/platform";
import Storege from "../services/storage/storage";
import Socket from "../services/socket/socket";
import BACKEND from "../services/api/backend";
import PlaylistStorage, { bindPlaylistsToStore, playlistErrorMessage } from "../services/playlists";

import "../services/content/content";
import "../services/api/subtitles";
import "../assets/icons"

import ColorButtons from "../popups/colorButtons/ColorButtons";
import { GetPlaylistContent, GetStartupPlaylist } from "../services/content/content";

bindPlaylistsToStore();

export default function () {

    const [current, setCurrent] = useState("loading");
    const [prevExitState, setPrevExitState] = useState("");

    const [token, setToken] = useStore("token");
    const [platform, setPlatform] = useStore("platform");
    const [deviceInfo, setDeviceInfo] = useStore("deviceInfo");
    const [playlists, setPlaylists] = useStore("playlists");
    const [language, setLanguage] = useStore("language");
    const [subtitleSettings, setSubtitleSettings] = useStore("subtitleSettings");
    const [rtlMode, setRtlMode] = useStore("rtlMode");

    const [error, setError] = useState(false);

    useEffect(() => {
        // set arabic direction
        if (rtlMode) {
            document.dir = "rtl";
            document.body.classList.remove("ltr");
            document.body.classList.add("rtl");
        } else {
            document.dir = "ltr";
            document.body.classList.remove("rtl");
        }
    }, [rtlMode])

    const registerDevice = async () => {

        var requestError = false;

        PlaylistStorage.setPlatform(platform.model);

        // the playlist store loads (and migrates the old local list) while registration runs; never rejects
        const playlistsReady = PlaylistStorage.init();

        // only kept to hand to the one-time import below; undefined = registration didn't answer
        let serverPlaylists = undefined;

        try {

            let { mac, model, version } = platform;

            let app_version = Config.APP_VERSION;

            var { device, token, playlists } = await BACKEND.registerDevice({ mac, model, os_version: version, app_version });

            serverPlaylists = playlists;

            Storege.setDevice(device);
            Storege.setToken(token);

        } catch (e) {

            requestError = true;

            // setTimeout(() => { registerDevice(); }, 10000);

        }

        if (requestError) {
            var device = Storege.getDevice();
            var token = Storege.getToken();
        }

        await playlistsReady;

        // saved once; after that the list register_device returns is ignored
        if (serverPlaylists !== undefined) await PlaylistStorage.importServerPlaylists(serverPlaylists);

        // the only source of the list from now on
        playlists = PlaylistStorage.getAll();

        let storage = PlaylistStorage.getStatus();

        if (storage.state == "unavailable" && storage.errorCode) {
            Toast.error({ msg: playlistErrorMessage(storage.errorCode), id: "playlist-storage", time: 6000 });
        }

        // per-playlist data is pruned only when the list is known to be complete
        if (PlaylistStorage.canPruneOrphanData()) Storege.syncPlaylistData(playlists.map((p) => p.id));

        if (device && token) {

            setDeviceInfo(device);
            setToken(token);
            setPlaylists(playlists);


            try{

                 let playlist = await GetStartupPlaylist(playlists);

                 if (playlist) {
                    let res = await GetPlaylistContent(playlist)

                    if(res == 'errorLogout'){

                          setError(true)
                    }
                 }
                
                setCurrent("menuPage");
            
         }catch(e){
                console.warn(e);
                setError(true)
                setCurrent("menuPage");
            }

        }

    }

    const initPlatform = async () => {

        try {

            let platform = new Platform();
            await platform.init();
            setPlatform(platform);

        } catch (e) {

            console.log("initPlatform error:", e);

            setTimeout(() => { initPlatform(); }, 1000);

        }

    }

    const exitApp = () => {
        hideExitPopup();
        platform.exit();
    }

    const hideExitPopup = () => {
        setCurrent(prevExitState);
        setPrevExitState("");
    }

    const showExitPopup = () => {

        if (platform.model == "android") return exitApp();

        if (current == "exit") return;

        setPrevExitState(current);

        setCurrent("exit");

    }


   

    // setup socket
    useEffect(() => {

        if (!deviceInfo) return;

        let { mac } = deviceInfo;

        Socket.connect(token, mac);

        const unsubscribeActiveEvent = Socket.on("activate", () => {
            setCurrent("loading");
            registerDevice();
        });

        const unsubscribeDeactivateEvent = Socket.on("deactivate", () => {
            setCurrent("loading");
            registerDevice();
        });

        return () => {
            Socket.disconnect();
            unsubscribeActiveEvent();
            unsubscribeDeactivateEvent();
        }

    }, [deviceInfo]);

    useEffect(() => {

        if (!platform) return;

        registerDevice();

    }, [platform]);

    useEffect(() => {

        initPlatform();

        setLanguage(Storege.getLanguage());

        setSubtitleSettings(Storege.getSubtitleSettings());
        setRtlMode(Storege.getRtlMode());

    }, []);

    useVisibility();
    
    return (
        <>
            <AppBackground />
            <SplashLoading isVisible={current == "loading"} />
            <MenuPage isVisible={current == "menuPage"} onBack={showExitPopup} error={error}  />
            <ExitPopup isVisible={current == "exit"} onCancel={hideExitPopup} onExit={exitApp} />
            <ConnectionPopup />
            <Toast />
            <ColorButtons />
        </>
    )
}